import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import Home from "./pages/home/home";
import "./App.css";
import PickPassword from "./pages/setup/pickPassword";
import Setup from "./pages/setup/setup";
import Login from "./pages/login/login";
import Saved from "./pages/setup/saved";

function App() {
  return (
    <Router basename="/app">
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />}  />
        <Route path="/activate/:deviceId" element={<PickPassword />} />
        <Route path="/reset-password/:deviceId" element={<PickPassword />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/saved/:deviceId?" element={<Saved />} />
      </Routes>
    </Router>
  );
}

export default App;
